import { useTranslation } from "react-i18next";

function SelectLanguage({ changeLanguage }) {

    const {t} = useTranslation();
  return (
    <div className="menu__modalOverlay">
      <div className="menu__modalContent">
        <h3>{t('languagepage.selectlang')}</h3>
        <button type="button" onClick={() => changeLanguage('English')}>
          English
        </button>
        <button type="button" onClick={() => changeLanguage('Swahili')}>
          Swahili
        </button>
      </div>
    </div>
  );
}

export default SelectLanguage;